import { initDataLayer, isBrowser, persistTrackingData } from '../util';
import { mapFlight } from '../util/mapFlight';
export function pushPreSelectedFlight(data) {
    var _a, _b;
    if (!isBrowser())
        return;
    initDataLayer();
    const preSelectedFlight = (_b = (_a = data.flightSearchResults) === null || _a === void 0 ? void 0 : _a.flights) === null || _b === void 0 ? void 0 : _b.find((flightSearchResult) => flightSearchResult.isPreSelected);
    if (!preSelectedFlight)
        return;
    const flightSearchResults = [mapFlight(preSelectedFlight)];
    window.dataLayer.push({
        event: 'flightPreSelectionLoaded',
        flightSearchResults,
    });
    persistTrackingData({ flightSearchResults });
}
